module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'finished': _vm.finished
    }
  }, [_c('div', {
    staticClass: "mtn h4 x-column x-sm mtn x-2-2 pull-right "
  }, [(_vm.finished) ? _c('button', {
    staticClass: "finishButton",
    on: {
      "click": function($event) {
        _vm.backToDashboard()
      }
    }
  }, [_vm._v("Back to Dashboard")]) : _vm._e()]), _vm._v(" "), (_vm.finished) ? _c('div', {
    staticClass: "questionNumberWrapper"
  }, [_vm._l((_vm.questions), function(question, questionNo) {
    return _c('button', {
      staticClass: "choice",
      class: {
        'answered': question.commited,
          'correct': question.commited && question.correct,
          'incorrect': question.commited && !question.correct
      },
      on: {
        "click": function($event) {
          _vm.currentQuestionIndex = questionNo
        }
      }
    }, [_vm._v("\n      " + _vm._s(questionNo + 1) + "\n      ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "choice finish x-icon-flag-checkered",
    attrs: {
      "data-x-icon": ""
    },
    on: {
      "click": function($event) {
        _vm.currentQuestionIndex = _vm.questions.length
      }
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "questionWrapper"
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "p",
      "mode": "out-in"
    }
  }, [(_vm.currentQuestionIndex == _vm.questions.length) ? _c('div', {
    key: "finish"
  }, [_c('h1', [_vm._v("SCORE: " + _vm._s(_vm.calculatedScore))]), _vm._v(" "), _c('h4', [_vm._v("questions answered: " + _vm._s(_vm.calculateTriedQuestions))]), _vm._v(" "), (_vm.paid) ? _c('h4', [_vm._v("questions answered correctly: " + _vm._s(_vm.calculateCorrectQuestions))]) : _vm._e(), _vm._v(" "), (_vm.serverFinishingResults != false) ? _c('h4', [_vm._v("!Questions answered correctly: " + _vm._s(_vm.serverFinishingResults))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.questions), function(question, qindex) {
    return (qindex == _vm.currentQuestionIndex) ? _c('div', {
      key: question.id,
      class: {
        'answered': question.commited
      }
    }, [_c('h4', {
      staticClass: "mtn h4 x-column x-sm mtn x-1-2 "
    }, [_c('span', [_vm._v("Question " + _vm._s(qindex + 1) + "/" + _vm._s(_vm.questions.length))]), _c('span', {
      staticClass: "smallID"
    }, [_vm._v("id:" + _vm._s(question.id))])]), _vm._v(" "), _c('div', {
      staticClass: "mtn h4 x-column x-sm mtn x-2-2 pull-right "
    }, [(!_vm.finished) ? _c('span', [_vm._v(_vm._s(_vm.timeSpent))]) : _vm._e(), _vm._v(" "), (!_vm.finished) ? _c('button', {
      staticClass: "finishButton",
      on: {
        "click": function($event) {
          _vm.finishTesting()
        }
      }
    }, [_vm._v("Finish Test")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "questionBox"
    }, [_c('div', {
      staticClass: "inner",
      domProps: {
        "innerHTML": _vm._s(question.question)
      }
    })]), _vm._v(" "), (question.type == 'multiple_choice') ? _c('multiple-choice-single-answer', {
      attrs: {
        "question": question,
        "paid": _vm.paid
      },
      on: {
        "answer": function($event) {
          _vm.answer(question, qindex, $event.choice, $event.choiceIndex)
        }
      }
    }) : _vm._e(), _vm._v(" "), (question.type == 'multiple_choice_multi_answer') ? _c('multiple-choice-multi-answer', {
      attrs: {
        "question": question,
        "paid": _vm.paid
      },
      on: {
        "answer": function($event) {
          _vm.answerMultipleChoice(question, qindex)
        }
      }
    }) : _vm._e(), _vm._v(" "), (question.type == 'acceptable_statement' || question.type == 'valid_statement') ? _c('acceptable-statement', {
      attrs: {
        "question": question,
        "paid": _vm.paid
      },
      on: {
        "answer": function($event) {
          _vm.answerMultipleChoice(question, qindex)
        }
      }
    }) : _vm._e(), _vm._v(" "), (question.type == 'drag_and_match') ? _c('drag-and-match', {
      attrs: {
        "question": question,
        "paid": _vm.paid
      },
      on: {
        "answer": function($event) {
          _vm.answerDraggable(question, qindex)
        }
      }
    }) : _vm._e(), _vm._v(" "), (question.type == 'multi_drag_and_match') ? _c('multi-drag-and-match', {
      attrs: {
        "question": question,
        "paid": _vm.paid
      },
      on: {
        "answer": function($event) {
          _vm.answerDraggable(question, qindex)
        }
      }
    }) : _vm._e(), _vm._v(" "), (question.type == 'input_answer') ? _c('input-answer', {
      attrs: {
        "question": question,
        "paid": _vm.paid
      },
      on: {
        "answer": function($event) {
          _vm.answer_input(question, qindex)
        }
      }
    }) : _vm._e(), _vm._v(" "), (question.commited) ? _c('button', {
      on: {
        "click": function($event) {
          _vm.nextQuestion()
        }
      }
    }, [_vm._v(_vm._s(_vm.continueOrFinish))]) : _vm._e(), _vm._v(" "), (question.commited && _vm.showExplanation) ? _c('div', {
      staticClass: "explanation",
      domProps: {
        "innerHTML": _vm._s(question.explanation_input)
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748fa058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Quiz.vue
// module id = 50
// module chunks = 0